import { AppBar, styled } from "@mui/material";

const FixedAppBar = styled(AppBar)(({ theme }) => ({
  top: "auto",
  bottom: 0,
  right: 0,
  left: 0,
  display: "flex",
  flexDirection: "row",
  backgroundColor: theme.palette.blackPrimary.main,
  alignItems: "center",
  justifyContent: "center",
}));

export default FixedAppBar;
